module.exports = __webpack_public_path__ + "img/trx.9e7fd96c.svg";